import { Accordion, AccordionHeader, AccordionItem } from 'QuoteApp/components';
import { VehicleDataType } from 'QuoteApp/services/endpoints/GetDetails';
import React, { FC } from 'react';
import { ADASFeatures } from '../ADASFeatures';
import { AdvancedFeatureInput } from '../AdvancedFeatureInput';

export const AdvancedFeatureVehicleCard: FC<{
  vehicle: VehicleDataType;
  vehicleId: string;
}> = ({ vehicle, vehicleId }) => {
  const vehicleName = `${vehicle.year.value} ${vehicle.make.value} ${vehicle.model.value}`;
  return (
    <Accordion>
      <AccordionItem
        identifier={`${vehicleName.replace(/ /g, '-')}-accordion`}
        startOpen
        header={<AccordionHeader header={vehicleName} />}
      >
        {ADASFeatures.map(feature => (
          <AdvancedFeatureInput
            key={`${vehicleName}-${feature.featureGroup}`}
            feature={feature}
            vehicleId={vehicleId}
            vehicleName={vehicleName}
          />
        ))}
      </AccordionItem>
    </Accordion>
  );
};
